import api from '@/api'
export default {
    /**
     * 공용연락처 목록 조회
     */
    getPublicContactsList(): Promise<orgmap.PuplicDistributionGroup[]> {
        return api.get<orgmap.PuplicDistributionGroup[]>({
            url: '/Mail/DistributionGroup/api/getList'
        })
    },

    /**
     * 공용연락처 구성원 조회
     * @param item 공용연락처
     */
    getPublicContactsMembersList(data: orgmap.DLGroupApiOption): Promise<orgmap.UserItem[]>{
        return api.post<orgmap.UserItem[]>({
            url: '/Mail/DistributionGroup/api/getMemberList',
            data: data
        });
    },    

    /**
     * 직원코드로 정보 조회
     * @param personCode 직원코드
     */
    getPersonInfo(personCode: string) {
        return api.get({
            url: '/Hr/department/api/person?personCode=' + personCode,
        })
    },
}
